/***************************************************************
Hawaiian Macadamia Nut Services
11/17/22
Alexander Self
Mech harvest form table
- Table that displays, updates and deletes new or edited harvest records
***************************************************************/
import React from 'react';

function MechHarvestFormTable({ 
  harvest,
  employees, 
  editHarvest, 
  deleteHarvest 
}) {
  if (!harvest) return <span></span>
  return (
    <table className="highlight bordered responsive-table centered">
      <thead>
        <tr className="harvest-headers">
          <th>Field</th>
          <th>Block</th>
          <th>Trees</th>
          <th>Hours</th>
          <th>Container Type</th>
          <th>Container #</th>
          <th>Est Lbs/Container</th>
          <th>Status</th>
          <th>Equipment</th>
          <th>Employee</th>
          <th>Edit</th>
          <th>Delete</th>
        </tr>
      </thead>
      <tbody>
        {
          harvest && harvest.map((h) => {
            let emp = employees.find((e) => e.eid === h.eid)
            return (
              <tr key={h.id ? h.id : h.guid}>
                <td>{ h.field }</td>
                <td>{ h.block }</td>
                <td>{ h.treesCovered }</td>
                <td>{ h.hours }</td>
                <td>{ h.containerType }</td>
                <td>{ h.containerCount }</td>
                <td>{ h.estLbsPerContainer }</td>
                <td>
                   { h.status === 0 || h.status === '0' ? <span className="label label-incomplete">Incomplete</span>
                      : <span className="label label-complete">Complete</span>
                   }
                </td>
                <td>{ h.equipmentNo }</td>
                <td>{ emp && `${emp.firstName[0]}. ${emp.lastName}` }</td>
                <td>
                <button onClick={() => editHarvest(h)} className="btn-floating waves-effect waves-light blue">
                  <i className="material-icons">mode_edit</i>
                </button>
              </td>
              <td>
                <button onClick={() => deleteHarvest(h.id ? h.id : h.guid)} className="btn-floating waves-effect waves-light red">
                  <i className="material-icons">clear</i>
                </button>
              </td>
              </tr>
            )
          })
        }
      </tbody>
    </table>
  );
}

export default MechHarvestFormTable;



// WEBPACK FOOTER //
// ./src/components/harvest/mechHarvest_form_table.jsx